<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import { useUserStore } from '@/stores'
import { onMounted } from 'vue'

const userStore = useUserStore()

const elementLocale = computed(() => {
  return userStore.language.startsWith('zh') ? zhCn : en
})

// Fetch user profile on app load if token exists
onMounted(() => {
  if (userStore.token && !userStore.user) {
    userStore.fetchProfile()
  }
})
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>